export default __webpack_public_path__ + "static/FooterLogo-ecafd2fa6ae3351d66a55ca0947d3581.png";